"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveAlias = resolveAlias;
exports.expandAliases = expandAliases;
const mergeFieldCatalog_1 = require("../mergeFieldCatalog");
/** Widened view of the catalog: the literal per-entry types from `as const`
 * don't all carry `aliases`, so a direct iteration needs the common shape. */
const CATALOG = mergeFieldCatalog_1.MERGE_FIELD_CATALOG;
const ALIAS_TO_CANONICAL = new Map(CATALOG.flatMap(d => (d.aliases ?? []).map((a) => [a, d.name])));
/** A legacy name maps to its canonical field; anything else maps to itself. */
function resolveAlias(name) {
    return ALIAS_TO_CANONICAL.get(name) ?? name;
}
/**
 * Emit BOTH spellings into frozen merge data, so already-seeded documents and
 * already-executed envelopes keep rendering byte-identically. The canonical
 * value always wins; an alias never overwrites it.
 */
function expandAliases(values) {
    const out = { ...values };
    for (const d of CATALOG) {
        const v = values[d.name];
        if (v === undefined)
            continue;
        for (const a of d.aliases ?? [])
            if (out[a] === undefined)
                out[a] = v;
    }
    return out;
}
//# sourceMappingURL=aliases.js.map